(function () {
  angular.module('MktzapApp.Controllers')
    .controller('ExthubConfigsController', exthubconfigsController);

  exthubconfigsController.$inject = ['$scope', 'ExthubConfigsService', 'NotificationService', '$rootScope'];

  function exthubconfigsController ($scope, ExthubConfigsService, NotificationService, $rootScope) {
    var vm = this;

    if ($rootScope.checkMenuAccess('lord')) {
      ExthubConfigsService
        .getConfigs()
        .$promise
        .then(function (data) {
          if (data.success == false) {
            NotificationService.errorHandler(data, 'Ocorreu um erro ao buscar configurações');
          } else {
            $scope.script = JSON.stringify(data.response.data, null, 2);
            $scope.originalScript = $scope.script;
            $scope.updateJsonObject();
          }
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Ocorreu um erro');
        });
    }

    $scope.updateJsonObject = function () {
      try {
        $scope.message = JSON.parse($scope.script);
        $scope.formatting = { color: 'green', 'background-color': '#d0e9c6' };
        vm.jsonValid = true;
      } catch (e) {
        $scope.formatting = { color: 'red', 'background-color': '#f2dede' };
        vm.jsonValid = false;
      }
    };

    $scope.save = function () {
      if ($rootScope.checkMenuAccess('lord')) {
        if ($scope.script == $scope.originalScript) {
          NotificationService.errorHandler(null, 'Não houve alteração de dados.');
          return;
        }

        ExthubConfigsService
          .saveConfigs($scope.script,
            function (response) {
              NotificationService.successHandler(null, 'Exthub_configs alterado com sucesso.');
            },
            function (error) {
              NotificationService.errorHandler(error, 'Não foi possível alterar.');
            })
      }
    }
  }
})();
